import { GetAllBones as s } from "@project-rouge/rg-core";
import { getBoneBoundary as a } from "./index2.js";
import { getBoundaries as d } from "./index3.js";
function u(n, e, t) {
  const r = s(n.data.anatomy).filter((o) => e.bones.includes(o.id)).map(
    (o) => a({
      building: n,
      bone: o,
      level: e.isRoof ? e.levelIndex - 1 : e.levelIndex,
      childrenToInclude: t
    })
  );
  return d(r, 0.03, 0, !0)[0];
}
export {
  u as getLevelBoundary
};
//# sourceMappingURL=index6.js.map
